import gql from "graphql-tag";
import tracker from "@/utils/event-tracker";

export default {
	methods: {
		async _removeTile(app) {
			try {
				await this.$confirm("Are you sure you want to remove this custom tile?", "Warning", {
					confirmButtonText: "Remove",
					cancelButtonText: "Cancel"
				});
			} catch (error) {
				return false;
			}

			try {
				this.loading = true;

				await this.$apollo.mutate({
					mutation: gql`
						mutation DeleteLink($id: String!) {
							DeleteLink(id: $id) {
								id
								name
								url
							}
						}
					`,
					variables: {
						id: app.id
					},
					update: (store, { data: { DeleteLink } }) => {
						if (!DeleteLink) return;

						try {
							if (this.$route.params.class) {
								const userQuery = gql`
									query getUser($classUuid: String!) {
										User {
											id
											Companies(classroom_uuid: $classUuid) {
												id
												classroom_uuid
											}
										}
									}
								`;

								const variables = {
									classUuid: this.$route.params.class
								};

								const userData = store.readQuery({
									query: userQuery,
									variables
								});

								userData.User.Companies = userData.User.Companies.filter(company => company.id !== app.id);
								store.writeQuery({ query: userQuery, variables, data: userData });
							}
						} catch (error) {
							// console.log("error", error);
						}

						try {
							const companyQuery = gql`
								query Companies {
									Companies {
										id
									}
								}
							`;

							const companyData = store.readQuery({ query: companyQuery });

							companyData.Companies = companyData.Companies.filter(company => company.id !== app.id);
							store.writeQuery({ query: companyQuery, data: companyData });
						} catch (error) {
							// console.log("error", error);
						}
					}
				});

				this.$message.success("Custom tile successfully deleted");
				tracker("custom-tile-removed", { tile_name: app.name, tile_id: app.id });

				return true;
			} catch (error) {
				console.error("error", error);
				this.$message.error("Failed to delete link");

				this.loading = false;

				return false;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/components/apps/tile/Remove.mixin.js